<script >
import {defineComponent} from 'vue'
import Vue3PersianDatetimePicker  from 'vue3-persian-datetime-picker';
import { dateInput, makeCode } from "@/shared/helper";

export default defineComponent({
  name: "DateInput",
  components : {DatePicker: Vue3PersianDatetimePicker},
  props : ['modelValue','required','dateTime','placeholder','label','name','requiredStar','isMilady'],
  emits: ['update:modelValue','change'],
  data(){
    return {
      code :'t'+makeCode(8),
      displaySelectedDate: '',
      isChange : false,
    }
  },
  computed: {
    value: {
      get() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        if (this.isMilady && this.modelValue && !this.isChange) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isChange = true;
          return dateInput(this.modelValue, this.dateTime);
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isChange = true;
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
})
</script>

<template>
  <div  class="form-group w-100 first-type">
    <label v-if="label" v-html="label" :class="'mb-2 '+(requiredStar?'required-star':'')"></label>
    <div class="item w-100">
      <date-picker
          class="w-100 datepicker"
          :format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
          locale="fa"
          :append-to="false"
          :teleport="false"
          v-model="value"
          dir="rtl"
          :name="name"
          :placeholder="placeholder"
          :type="(dateTime?'datetime':'date')"
          :display-format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
      />
    </div>
  </div>
</template>

<style scoped >

</style>